<template>
	<div class="right_body action_body">
		<span class="btn right_sub_btn save_btn" @click.stop="saveMatter" :disabled="isDisable">提交数据</span>
		<el-tabs v-model="activeName" @tab-click="handleClick" v-loading="$store.state.isLoading">
			<el-tab-pane label="基础数据" name="base">
				<base-edit
        ref="baseFrom"
        :isEdit="isEdit"
				:fromData="fromData"
				:unitList="unitList" 
				:MaterialType="matterTypeList"
				:MaterialGroup="matteGroup"
				v-if="isChildComponent"
        @saveMatter="saveMatter"
				></base-edit>
			</el-tab-pane>
			<el-tab-pane label="存储数据" name="save">
				<save-edit
				:fromData="fromData"
				:unitList="unitList"
				v-if="isChildComponent"
				></save-edit>
			</el-tab-pane>
			<!-- <el-tab-pane label="工厂数据" name="factory" v-if="factoryList.length">
				<factory-edit
				:fromData="fromData"
        :rules="rules"
				:unitList="unitList"
				:factoryList="factoryList"
				:forDataFactory="forDataFactory"
				v-if="isChildComponent">
				</factory-edit>
			</el-tab-pane> -->
      <el-tab-pane label="财务数据" name="finance">
				<finance-edit
				:fromData="fromData"
        :factoryList="factoryList"
        :MaterialType="matterTypeList"
				v-if="isChildComponent"
				></finance-edit>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import { mapState,mapActions } from 'vuex';
import {matterApi,matterTypeApi,matterGropApi,measureUnitApi,factoryApi} from 'api/base.js';

import baseEdit from './components/add/base.vue'
import saveEdit from './components/add/save.vue'
import factoryEdit from './components/add/factory.vue'
import financeEdit from './components/add/materialPriceNewPanel.vue';
import eventBus from './../../../main.js';


export default {
	components:{
		baseEdit,
		saveEdit,
    factoryEdit,
    financeEdit
	},
  data() {
    return {
      activeName: 'base',
      isDisable:false,
      id:'',
      isEdit:false,
      isChildComponent:false,
      forDataFactory:{},
      fromData:{
        "mtrlFactorys": [],
        "multiUnit": [],
        "materialPrice": {
          "unitPriceQty":'1',
          "priceUnitDesc":'CNY',
          "priceControlIndicator":'V',
          "estimatedInventory":'0'
        }
      },
      getAllPage:this.$store.state.getAllPage
    }
  },
	created(){
    this.id = this.$route.params.id;
    console.log("this");
    console.log(this);
    //this.$route.meta.key=false;  
    this.getInit();
    this.registerEventListener();
	},
  computed:{
    ...mapState('cache',[
      "factoryList",
      "unitList",
      "matterTypeList",
      "matteGroup"
    ])
  },
	mounted(){

  },
  methods: {
    ...mapActions('cache',[
      "setFactoryList",
      "setMatterTypeList",
      "setMatteGroup",
      "setUnitList"
    ]),
    handleClick(tab, event) {
    },
    /**
     * 注册事件监听
     */
    registerEventListener(){
      //点击tab页 
      this.$bus.on('onClickTabPage', this.onClickTabPage);
      //移除tab页
      this.$bus.on('onRemoveTabPage', this.onRemoveTabPage);
    },
    //移除tab页
    onRemoveTabPage(tabName){
       //this.$route.meta.clearCache=true;
       console.log("onRemoveTabPage clearCache="+this.$route.meta.clearCache);
    },  
    //点击tab页 
    onClickTabPage(tabName){
       //this.$route.meta.clearCache=false;
        console.log(" onClickTabPage clearCache="+this.$route.meta.clearCache);
    },
	  //获取初始数据
	  async getInit(){
      let id = this.$route.params.id;
      //获取当前数据
      if(id){//编辑
        let detail = await this.$get(matterApi.find,{'materialId':this.id});
        if(detail.status){
          console.log(detail.data)
          this.isEdit = true;
          this.fromData = detail.data;
          this.fromData.materialPrice = {
          "unitPriceQty":'1',
          "priceUnitDesc":'CNY',
          "priceControlIndicator":'V',
          "basicUnitDesc":detail.data.basicUnitDesc
          }
        }
      }

      //获取单位列表
      if(!this.unitList){
        let unitList = await this.$post(measureUnitApi.list,this.getAllPage);
        if(unitList.status) this.setUnitList(unitList.data.list);
      }

      //获取物料类型列表
      if(!this.matterTypeList){
        let MaterialType = await this.$post(matterTypeApi.list,this.getAllPage);
        if(MaterialType.status){
            MaterialType.data.list.forEach((item)=>{
              item.value = item.materialType+'-' + item.materialTypeDesc;
            });
            this.setMatterTypeList(MaterialType.data.list);
        } 
      }

      //获取物料组列表
      if(!this.matteGroup){
        let MaterialGroup = await this.$post(matterGropApi.list,this.getAllPage);
        if(MaterialGroup.status) this.setMatteGroup(MaterialGroup.data.list);
      }

      //获取工厂列表
      if(!this.factoryList){
        let factoryList = await this.$post(factoryApi.list,this.getAllPage);
        if(factoryList.status){
          factoryList.data.list.forEach((item)=>{
		      item.value = item.factoryCode+'-' + item.factoryDesc;
		    });
          this.setFactoryList(factoryList.data.list);
        } 
      }
      this.isChildComponent = true;

    },
	  //保存提交数据
	  async saveMatter(){ 
      let vm = this; 
      //基础数据
      this.$refs.baseFrom.validataForm();
      let baseRes = this.$refs.baseFrom.regRes;
      if(!baseRes) return;
      //判断验证
      if(!this.fromData.materialDesc){
        this.$message.error('物料描述不能为空');
        return false;
      }

      let id = this.$route.params.id;
      var postUrl = matterApi.add;
      if(id) postUrl = matterApi.edit;
      //console.log(JSON.stringify(this.fromData));return;
      //清空工厂
      this.fromData.mtrlFactorys = [];
      // this.fromData.lastModifyDate = this.fromData.createDate
      // this.fromData.modifyUserName = this.fromData.createUserName
      console.log(JSON.stringify(this.fromData))
      this.isDisable = true;
      $(".save_btn").hide();
      let res = await this.$post(postUrl,this.fromData);
      this.isDisable = false;
      if(res.status){
        this.$set(this.fromData,"mtrlFactorys",[]);
        this.$set(this.fromData,"multiUnit",[]);
        let successMsg = id ? "物料"+res.data.materialCode + "修改成功" : "物料"+res.data.materialCode + "创建成功";
        this.$alert(successMsg,"操作提示", {
          confirmButtonText: '确定',
          callback: action => {
           //vm.$router.push({name: 'base-matter-list'});   
            this.$keepAliveManager.backSourceRoute(this,{name: 'base-matter-list'});
          }
        });
        //this.$router.push({name: 'base-matter-detail', params: {id:res.data.materialId}});
      }else{
        this.$message.error(res.errorMsg);
         $(".save_btn").show();
      }
      return;
	  },
	  //
    }
  };
</script>

<style lang="stylus" scoped>

</style>
